/**
 * @generated SignedSource<<0d7217c7c197536cfdc0a6567ec15257>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainPushNotificationMutation$variables = {
  id: string;
  sendNotificationAtPublish: boolean;
};
export type WorkspaceTodoEditMainPushNotificationMutation$data = {
  readonly todoWorkspace: {
    readonly updateNotification: {
      readonly sendNotificationAtPublish: boolean;
      readonly updatedAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceTodoEditMainPushNotificationMutation$rawResponse = {
  readonly todoWorkspace: {
    readonly updateNotification: {
      readonly id: string;
      readonly sendNotificationAtPublish: boolean;
      readonly updatedAtDate: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceTodoEditMainPushNotificationMutation = {
  rawResponse: WorkspaceTodoEditMainPushNotificationMutation$rawResponse;
  response: WorkspaceTodoEditMainPushNotificationMutation$data;
  variables: WorkspaceTodoEditMainPushNotificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sendNotificationAtPublish"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "sendNotificationAtPublish",
    "variableName": "sendNotificationAtPublish"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendNotificationAtPublish",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "updatedBy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditMainPushNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateNotification",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoEditMainPushNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateNotification",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc200ae65f74bbf39b5eb283ed4b01a4",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditMainPushNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditMainPushNotificationMutation(\n  $id: ID!\n  $sendNotificationAtPublish: Boolean!\n) {\n  todoWorkspace(id: $id) {\n    updateNotification(sendNotificationAtPublish: $sendNotificationAtPublish) {\n      sendNotificationAtPublish\n      updatedAtDate {\n        ...FormattedDate\n      }\n      updatedBy {\n        name\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "2e29f480f0fe7de9ff0b24a3ba9e221d";

export default node;
